<!-- Global Feedback Toast -->
@if (waiterService.toast(); as t) {
<div
  class="fixed top-4 sm:top-6 left-1/2 -translate-x-1/2 z-50 max-w-sm sm:max-w-md w-[calc(100%-2rem)] flex items-center justify-between gap-3 px-4 py-3 rounded-2xl shadow-2xl backdrop-blur-md border animate-in fade-in slide-in-from-top-4 duration-200 transition-all pointer-events-auto"
  [ngClass]="{
    'bg-emerald-600 text-white border-emerald-500 shadow-emerald-950/20': t.type === 'success',
    'bg-amber-600 text-white border-amber-500 shadow-amber-950/20': t.type === 'warning',
    'bg-red-600 text-white border-red-500 shadow-red-950/20': t.type === 'error'
  }">
  <div class="flex items-center gap-2.5 min-w-0">
    <!-- Icon according to type -->
    @if (t.type === 'success') {
    <div class="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center shrink-0">
      <svg class="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
      </svg>
    </div>
    } @else if (t.type === 'warning') {
    <div class="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center shrink-0">
      <svg class="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
    </div>
    } @else {
    <div class="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center shrink-0">
      <svg class="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
      </svg>
    </div>
    }
    <p class="text-xs sm:text-sm font-semibold leading-snug truncate-2-lines">
      {{ t.text }}
    </p>
  </div>

  <button type="button" (click)="dismissToast()" class="text-white/80 hover:text-white p-1 rounded-full shrink-0 cursor-pointer transition-colors" aria-label="Dismiss">
    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
</div>
}

<!-- Floating Table Quick Actions (Seated Table Diner with TableCall Enabled) -->
@if (waiterService.isTableCallAvailable()) {
<div class="fixed left-1/2 -translate-x-1/2 z-35 flex flex-col items-center max-w-lg w-[calc(100%-1.25rem)] sm:w-auto transition-all duration-300 pointer-events-none"
  [class.bottom-22]="isProductDetail()" [class.sm:bottom-24]="isProductDetail()" [class.bottom-3]="!isProductDetail()" [class.sm:bottom-5]="!isProductDetail()">

  <div class="pointer-events-auto bg-surface/95 backdrop-blur-md border border-border shadow-2xl rounded-2xl p-1.5 sm:p-2 flex flex-col gap-1.5 w-full">

    <!-- Expandable Optional Note Bar -->
    @if (isNoteOpen()) {
    <div class="p-2 sm:p-2.5 rounded-xl bg-background border border-border/80 flex flex-col gap-2 animate-in fade-in slide-in-from-bottom-2 duration-150">
      <div class="flex items-center justify-between text-[11px] text-muted font-medium">
        <span>{{ 'WAITER.NOTE_PLACEHOLDER' | translate }}</span>
        <button type="button" (click)="resetNote()" class="text-muted hover:text-main cursor-pointer">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Quick Chips -->
      <div class="flex items-center gap-1.5 flex-wrap">
        <button type="button" (click)="selectChip('WAITER.NOTE_WATER')" class="px-2 py-1 rounded-lg text-[11px] font-medium transition-colors cursor-pointer border"
          [ngClass]="selectedQuickKey() === 'WAITER.NOTE_WATER' ? 'bg-primary text-white border-primary' : 'bg-surface text-main border-border hover:bg-surface-hover'">
          💧 {{ 'WAITER.NOTE_WATER' | translate }}
        </button>
        <button type="button" (click)="selectChip('WAITER.NOTE_NAPKINS')" class="px-2 py-1 rounded-lg text-[11px] font-medium transition-colors cursor-pointer border"
          [ngClass]="selectedQuickKey() === 'WAITER.NOTE_NAPKINS' ? 'bg-primary text-white border-primary' : 'bg-surface text-main border-border hover:bg-surface-hover'">
          🧻 {{ 'WAITER.NOTE_NAPKINS' | translate }}
        </button>
        <button type="button" (click)="selectChip('WAITER.NOTE_CUTLERY')" class="px-2 py-1 rounded-lg text-[11px] font-medium transition-colors cursor-pointer border"
          [ngClass]="selectedQuickKey() === 'WAITER.NOTE_CUTLERY' ? 'bg-primary text-white border-primary' : 'bg-surface text-main border-border hover:bg-surface-hover'">
          🍴 {{ 'WAITER.NOTE_CUTLERY' | translate }}
        </button>
        <button type="button" (click)="selectChip('WAITER.NOTE_CASH')" class="px-2 py-1 rounded-lg text-[11px] font-medium transition-colors cursor-pointer border"
          [ngClass]="selectedQuickKey() === 'WAITER.NOTE_CASH' ? 'bg-primary text-white border-primary' : 'bg-surface text-main border-border hover:bg-surface-hover'">
          💵 {{ 'WAITER.NOTE_CASH' | translate }}
        </button>
        <button type="button" (click)="selectChip('WAITER.NOTE_CARD')" class="px-2 py-1 rounded-lg text-[11px] font-medium transition-colors cursor-pointer border"
          [ngClass]="selectedQuickKey() === 'WAITER.NOTE_CARD' ? 'bg-primary text-white border-primary' : 'bg-surface text-main border-border hover:bg-surface-hover'">
          💳 {{ 'WAITER.NOTE_CARD' | translate }}
        </button>
      </div>

      <!-- Custom Note Input -->
      <div class="relative flex items-center">
        <input type="text" [(ngModel)]="customNote" [placeholder]="'WAITER.NOTE_PLACEHOLDER' | translate"
          class="w-full text-xs px-3 py-1.5 rounded-lg bg-surface border border-border focus:outline-none focus:ring-1 focus:ring-primary text-main pr-7 placeholder:text-muted/60" />
        @if (customNote().length > 0) {
        <button type="button" (click)="customNote.set(''); selectedQuickKey.set(null)" class="absolute right-2 text-muted hover:text-main cursor-pointer">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        }
      </div>
    </div>
    }

    <!-- Main Bar Row -->
    <div class="flex items-center gap-1.5 sm:gap-2">
      <!-- Table Identifier Badge with Note Toggle -->
      <button type="button" (click)="toggleNote()"
        class="flex items-center gap-1.5 px-2.5 py-2 rounded-xl bg-background hover:bg-surface-hover border border-border text-xs font-semibold text-main transition-colors cursor-pointer shrink-0"
        [title]="'WAITER.ADD_NOTE' | translate">
        <span class="relative flex h-2 w-2 shrink-0">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
        </span>
        <span class="truncate max-w-[70px] sm:max-w-[100px]">
          {{ waiterService.tableDisplayName() }}
        </span>
        <!-- Note Indicator Icon / Badge -->
        <svg class="w-3.5 h-3.5 transition-colors" [ngClass]="getEffectiveDescription() ? 'text-primary' : 'text-muted'" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
        </svg>
      </button>

      <!-- Call Waiter Button (Type: 20) -->
      <button type="button" (click)="onCallWaiter()" [disabled]="waiterService.isBusy()"
        class="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 sm:px-4 rounded-xl text-xs font-bold transition-all duration-200 cursor-pointer shadow-xs active:scale-95 disabled:active:scale-100 border"
        [ngClass]="{
          'bg-amber-500 hover:bg-amber-600 text-white border-amber-500 shadow-amber-500/20': !waiterService.isBusy(),
          'bg-amber-100 text-amber-900 border-amber-300 opacity-80 cursor-wait': waiterService.isSubmitting() && waiterService.submittingType() === NotificationType.TABLE_CALL,
          'bg-surface-hover text-muted border-border opacity-70 cursor-not-allowed': waiterService.isBusy() && !(waiterService.isSubmitting() && waiterService.submittingType() === NotificationType.TABLE_CALL)
        }">
        <!-- Icon / Spinner / Clock -->
        @if (waiterService.isSubmitting() && waiterService.submittingType() === NotificationType.TABLE_CALL) {
        <svg class="w-4 h-4 animate-spin shrink-0 text-amber-800" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        <span>{{ 'WAITER.CALLING' | translate }}</span>
        } @else if (waiterService.isCooldownActive()) {
        <svg class="w-4 h-4 shrink-0 text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
        <span class="tabular-nums">{{ 'WAITER.WAIT_COOLDOWN' | translate: { seconds: waiterService.cooldownSeconds() } }}</span>
        } @else {
        <!-- Bell Icon -->
        <svg class="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
        </svg>
        <span class="truncate">{{ 'WAITER.CALL_WAITER' | translate }}</span>
        }
      </button>

      <!-- Request Bill Button (Type: 30) -->
      <button type="button" (click)="onRequestBill()" [disabled]="waiterService.isBusy()"
        class="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 sm:px-4 rounded-xl text-xs font-bold transition-all duration-200 cursor-pointer shadow-xs active:scale-95 disabled:active:scale-100 border"
        [ngClass]="{
          'bg-primary hover:opacity-90 text-primary-foreground border-primary shadow-primary/20': !waiterService.isBusy(),
          'bg-primary/20 text-primary border-primary/40 opacity-80 cursor-wait': waiterService.isSubmitting() && waiterService.submittingType() === NotificationType.BILL_REQUEST,
          'bg-surface-hover text-muted border-border opacity-70 cursor-not-allowed': waiterService.isBusy() && !(waiterService.isSubmitting() && waiterService.submittingType() === NotificationType.BILL_REQUEST)
        }">
        <!-- Icon / Spinner / Clock -->
        @if (waiterService.isSubmitting() && waiterService.submittingType() === NotificationType.BILL_REQUEST) {
        <svg class="w-4 h-4 animate-spin shrink-0 text-primary" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        <span>{{ 'WAITER.REQUESTING' | translate }}</span>
        } @else if (waiterService.isCooldownActive()) {
        <svg class="w-4 h-4 shrink-0 text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
        <span class="tabular-nums">{{ 'WAITER.WAIT_COOLDOWN' | translate: { seconds: waiterService.cooldownSeconds() } }}</span>
        } @else {
        <!-- Receipt / Bill Icon -->
        <svg class="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
        <span class="truncate">{{ 'WAITER.REQUEST_BILL' | translate }}</span>
        }
      </button>
    </div>
  </div>
</div>
}